import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { AnimatePresence, motion } from 'framer-motion';
import { observer } from 'mobx-react';
import { DisplayText } from '../../display-text/display-text';
const b = bemClassBuilder('v-help-text');
const helpTextMotionProps = {
    initial: { opacity: 0, height: 0 },
    animate: {
        opacity: 1,
        height: 'auto',
        transition: {
            height: { duration: 0.2 },
            opacity: { duration: 0.1, delay: 0.1 }
        }
    },
    exit: {
        opacity: 0,
        height: 0,
        transition: {
            height: { duration: 0.2 },
            opacity: { duration: 0.1 }
        }
    }
};
/**
 * Renders a help text component.
 *
 * This component should be rendered unconditionally, as it will animate in and out based on the presence of the text prop.
 */
export const HelpText = observer(props => {
    const { id, text, style, className, children, internalActions } = props;
    return (_jsx(AnimatePresence, { children: text && (_jsxs(motion.div, Object.assign({ id: id, className: b.block({ style }, className) }, helpTextMotionProps, { children: [_jsx(DisplayText, { label: text, internalActions: internalActions }), children] }), id)) }));
});
HelpText.displayName = 'HelpText';
//# sourceMappingURL=help-text.js.map